import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const paymentMethodService = {
  async getAllAsync() {
    const response = await apiClient.get(endPoints.paymentMethod.getAll);
    return response.data;
  },

  async create(data) {
    const response = await apiClient.post(endPoints.paymentMethod.create, data);
    return response.data;
  },

  async update(id, data) {
    const response = await apiClient.put(`${endPoints.paymentMethod.update}/${id}`, data);
    return response.data;
  },

  async toggleAvailable(id) {
    const response = await apiClient.patch(`${endPoints.paymentMethod.toggle}/${id}/toggle`);
    return response.data;
  },

  async deleteAsync(id) {
    const response = await apiClient.delete(`${endPoints.paymentMethod.delete}/${id}`);
    return response.data;
  },
};
